import React, { useLayoutEffect } from 'react';
import {
	BrowserRouter as Router,
	Route,
	Switch,
	Redirect
} from 'react-router-dom';

import CookieMessage from '../CookieMessage';
import Notification from '../Notification';
import ScrollToTop from '../ScrollToTop';
import Header from '../Header';
import Footer from '../Footer';
import Prayer from '../Prayer';
import NotFoundPage from '../404';
import HelpPage from '../Help';
import Maintenance from '../Maintenance';
import ErrorPage from '../Error';

import * as THEME from '../../constants/theme.js';
import * as ROUTES from '../../constants/routes';
import useLocalStorage from '../../useLocalStorage';

const App = () => {
	const maintenance = false;
	const isIE = window.document.documentMode;
	const [theme, setTheme] = useLocalStorage('theme', '');
	const [ageLevel, setAgeLevel] = useLocalStorage('ageLevel', '');
	const darkModeQuery = window.matchMedia('(prefers-color-scheme: dark)');

	if (!theme.name) {
		if (isIE) {
			setTheme(THEME.LIGHT);
		} else if (window.matchMedia && darkModeQuery.matches) {
			setTheme(THEME.DARK);
		} else {
			setTheme(THEME.LIGHT);
		}
	}

	darkModeQuery.onchange = (event) => {
		if (event.matches) {
			setTheme(THEME.DARK)
		} else {
			setTheme(THEME.LIGHT);
		}
	}

	if (!ageLevel) {
		setAgeLevel('earlyChildhood');
	}

	useLayoutEffect(() => {
		document.documentElement.setAttribute('data-theme', theme.name);
		document.querySelector('meta[name="theme-color"]').setAttribute('content', theme.color);
	}, [theme]);

	// bfcache fix
	window.onpageshow = function(event) {
		if (event.persisted) {
			window.location.reload();
		}
	}

	if (maintenance) {
		return (
			<>
				<Maintenance />
				<Modals />
			</>
		);
	} else {
		return (
			<Router>
				<ScrollToTop />
				<Header />

				<main>
					<Switch>
						<Route exact path="/">
							<Redirect to={ ageLevel === 'earlyChildhood' ? '/early-childhood' : `/${ageLevel}`} />
						</Route>
						<Route exact path={ROUTES.HELP} component={() => (<HelpPage />)} />
						<Route exact path={ROUTES.NOT_FOUND} component={NotFoundPage} />
						<Route exact path={ROUTES.ERROR} component={ErrorPage} />
						<Route exact path={ROUTES.EARLY} component={() => (<Prayer level="earlyChildhood" title="Early Childhood" />)} />
						<Route exact path={ROUTES.ELEMENTARY} component={() => (<Prayer level="elementary" title="Elementary" />)} />
						<Route exact path={ROUTES.PRETEEN} component={() => (<Prayer level="preteen" title="Preteen" />)} />
						<Route component={NotFoundPage} />
					</Switch>
				</main>

				<Footer />
				<Modals />
			</Router>
		);
	}
};

const Modals = () => (
	<div className="modals">
		<Notification />
		<CookieMessage />
	</div>
);

export default App;